import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { Basicinfo } from './Basicinfo';
import { Adressdetail } from './Adressdetail'; // Assuming this is your second tab component
import { useDispatch } from 'react-redux';
import { submitBusinessForm } from '../../actions/setup';
import { businessDetailsAction, getAllBusinessCategories, getAllRewards } from '../../actions/business';
import { useSelector } from 'react-redux';
import './style.css'
import { RewardWrapper } from './RewardWrapper';
import InviteBusiness from '../../pages/ComapanyIRefer/InviteBusiness';

const BusinessSetup = () => {
    const dispatch = useDispatch();
    const [activeStep, setAtiveStep] = useState('1')
    const user = useSelector((state: any) => state?.Auth);
    const isLoading = useSelector((state: any) => state?.General?.loading);
    const [services, setServices] = useState<any>([])
    const [businessInfo, setBusinessInfo] = useState({
        businessName: '',
        referUsURL: '',
        backgroundColor: '',
        businessCategory: '',
        businessDescription: '',
        services: '',
        pinCode: '',
        profilePic: null,
        bannerPic: null,
        lat: 0,
        long: 0
    });

    let userData = user?.user?.data || user?.user?.user;

    const getBusinessData =()=> {
        const payload = {
            businessCode: userData?.businessCode
        }
        dispatch(
            businessDetailsAction(payload, (resp: any) => {
                if(resp?.status === 200) {
                    setBusinessInfo(resp?.data)
                    setServices(resp?.data?.services ? resp?.data?.services.split(',') : []);
                }
            })
        );
    }

    useEffect(() => {
        getBusinessData()
        dispatch(
            getAllRewards({}, (resp: any) => {})
        );
        dispatch(getAllBusinessCategories({}, () => { }))
    }, [location])

    const handleFirstStepSubmit =(values: any)=> {
        // Accessing specific color properties (e.g., rgb)
        const hexString = `#${values?.backgroundColor?.metaColor?.r?.toString(16).padStart(2, '0')}${values?.backgroundColor?.metaColor?.g?.toString(16).padStart(2, '0')}${values?.backgroundColor?.metaColor?.b?.toString(16).padStart(2, '0')}`;
        if(values?.backgroundColor?.metaColor && hexString) {
            values.backgroundColor = hexString;
        }
        if(values) {
            dispatch(
                submitBusinessForm(values, (resp: any) => {
                    if (resp?.success) {
                        setAtiveStep('2')
                        console.warn('Form submission successful');
                        getBusinessData()
                    }
                })
            );
        }
    }

    const handleSecondStepSubmit =(values: any)=> {
        if(values) {
            setAtiveStep('3')
            dispatch(
                submitBusinessForm(values, (resp: any) => {
                    if (resp?.success) {
                        console.warn('Form submission successful');
                        getBusinessData()
                    }
                })
            );
        }
    }
    const handleRewardSubmit =(values: any)=> {
        if(values) {
            setAtiveStep('4')
        }
    }

    const items = [
        {
            key: '1',
            label: 'Basic Information',
            children: (
                <Basicinfo businessInfo={businessInfo} setBusinessInfo={setBusinessInfo} handleSubmit={handleFirstStepSubmit} />
            ),
        },
        {
            key: '2',
            label: 'Address & Contact Details',
            children: (
                <Adressdetail businessInfo={businessInfo} setAtiveStep={setAtiveStep} handleSubmit={handleSecondStepSubmit} setBusinessInfo={setBusinessInfo} />
            ),
        },
        {
            key: '3',
            label: 'Rewards',
            children: (
                <RewardWrapper setAtiveStep={setAtiveStep} handleSubmit={handleRewardSubmit} />
            ),
        },
        {
            key: '4',
            label: 'Invite Business',
            children: (
                <InviteBusiness disableHeader={true} inviteInfo={true} setAtiveStep={setAtiveStep}/>
            ),
        },
    ];

    const handleChange = (activeKey: string) => {
        // Add your logic here to handle the tab change
        if(userData?.isSetupCompleted) {
            setAtiveStep(activeKey)
        }
      };

    return (
        <Tabs onChange={handleChange} defaultActiveKey={activeStep} activeKey={activeStep} items={items} />
    );
};

export default BusinessSetup;
